<div class="row container-form-list mb-4">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h5 class="card-title mb-0">E-commerces</h5>    
                <small class="card-subtitle">Informe os e-commerces deste cliente</small>
            </div>
            <div class="table-responsive">
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <th class="col-delete" *ngIf="canEdit"></th>
                            <th class="col-tipo">Tipo</th>
                            <th class="col-nome">Nome Vendedor</th>
                            <th class="col-url">Link</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entity of entities; let i = index">
                            <td class="col-delete" *ngIf="canEdit">
                                <a class="btn btn-link" (click)="delete(i)">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="col-tipo">
                                <select class="form-control" name="tipo_{{i}}" id="tipo_{{i}}" 
                                    [ngModel]="entity.tipo || ''" (ngModelChange)="entity.tipo = $event ? $event : null"
                                    #tipo="ngModel" #tipoSelect required="required" [disabled]="!canEdit">
                                    <option value="">Selecione o tipo...</option>
                                    <option *ngFor="let tipo of tipos" [ngValue]="tipo.id">{{tipo.nome}}</option>
                                </select>  
                                <sgt-form-control-error
                                    *ngIf="tipo.errors && tipo.errors.required && tipo.dirty"
                                    msgError="O tipo é obrigatório">
                                </sgt-form-control-error>                                      
                            </td>
                            <td class="col-nome">
                                <input type="text" class="form-control" [(ngModel)]="entity.nome" name="nome_{{i}}" id="nome_{{i}}"
                                    #nome="ngModel" maxlength="255" [readonly]="!canEdit">
                                <sgt-form-control-error
                                    *ngIf="nome.errors && nome.errors.maxlength"
                                    msgError="O nome deve ter no máximo 255 caracteres">
                                </sgt-form-control-error>                                    
                            </td>                                
                            <td class="col-url">
                                <sgt-url [(ngModel)]="entity.url" name="url_{{i}}" id="url_{{i}}"
                                    #url="ngModel" [ngControl]="url" required="required" maxlength="255" [disabled]="!canEdit" [readonly]="!canEdit">
                                </sgt-url>
                                <sgt-form-control-error
                                    *ngIf="url.errors && url.errors.required && url.dirty"
                                    msgError="O link é obrigatório">
                                </sgt-form-control-error>
                                <sgt-form-control-error
                                    *ngIf="url.errors && url.errors.maxlength"
                                    msgError="O link deve ter no máximo 255 caracteres">
                                </sgt-form-control-error>                                      
                            </td>
                        </tr>
                        <tr *ngIf="entities.length === 0" class="no-record">
                            <td class="text-center" colspan="4">
                                <i class='fas fa-info' aria-hidden='true'></i> Nenhum e-commerce encontrado
                            </td>
                        </tr>
                    </tbody>                   
                </table>
            </div>
            <div class="card-footer" *ngIf="canEdit">
                <button type="button" class="btn btn-primary" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i> <span class="d-none d-sm-inline-block">Adicionar E-commerce</span>
                </button>
            </div>
        </div>        
    </div>
</div>
    